
import { Component, Vue } from "vue-property-decorator";
import { dataVisualizationModule } from "@/store";

@Component
export default class Rating extends Vue {

  headerTranslations: Record<string, string> = {
    //Identifier: "Kennung",
    Value: "Wert",
    PatientCount: "Anzahl der Patienten",
    PatientPercentage: "Prozentsatz der Patienten"
  };

  // Use new getter with key-based data
  get chartData(): any[] {
    return dataVisualizationModule.getChartData("rating");
  }

  get tableHeaders(): string[] {
    return this.chartData.length ? Object.keys(this.chartData[0]) : [];
  }

  async mounted() {
    try {
      await dataVisualizationModule.loadAll("rating");
    } catch (e) {
      console.error("Failed to load chart data:", e);
    }
  }
}
